<template>
  <div class="card_box">
    <div class="title">
      <span>{{index+1}}</span> ＃{{title}}
    </div>
    <div class="data">{{talkCnt}} 在讨论</div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String
    },
    talkCnt: {
      type: Number
    },
    id: {
      type: Number
    },
    index: {
      type: Number
    }
  }
}
</script>

<style lang="scss" scoped>
.card_box {
    font-family: PingFang SC;

    .data {
        margin: 9.5px 0 0 15px;
        font-size: 12px;
        font-weight: 400;
        color: #999999;
    }
    .title {
        font-size: 15px;
        font-weight: 500;
        color: #333333;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;

        span {
            font-weight: 600;
            color: #F49B44;
            margin-right: 4px;
        }
    }
}

</style>
